import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setCreateWidget } from "../../redux/actions/WidgetMaker/WidgetAPI";
import {
  getCustomizedDate,
  getPaneIndex,
  updateChartSettingsInGraphObjectBasedOnSelection,
} from "../../redux/constants";
import moment from "moment";
import { setisFilterPanelVisible } from "../../redux/actions/Filter";
import { setY_attribute } from "../../redux/actions/WidgetMaker/GraphConfig";
import { setWidgetLibraryFilter } from "../../redux/actions/WidgetMaker/WidgetLibrary";
import uuid from "react-uuid";
import { supportedBenchmarkTraceChartTypes } from "../../redux/constants/enums";

const ExitModal = ({
  setVisible,
  visible,
  description,
  type,
  resetWidgetMaker,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const isEditWidget = useSelector((state) => state.WidgetLibrary.editWidget);

  const authParams = useSelector((state) => state.Authentication.authParams);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const chartName = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.chart_property?.chart_name
  );
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);

  const widgetTag = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.tags
  );
  const widgetLibraryFilter = useSelector(
    (state) => state?.WidgetLibrary?.widgetLibraryFilter
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);

  const [flag, setflag] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);

  const modalClose = () => {
    setVisible(false);
  };

  const handleExitWidget = () => {
    let pathName = window.location.pathname?.split("/")?.[1];
    if (
      pathName === "dashboard" ||
      pathName === "pin-dashboard" ||
      pathName === "all-dashboard"
    ) {
      // Close the Filter Drawer pannel
      dispatch(setisFilterPanelVisible(false));

      // console.log("panes on back", panes?.[index]);
      let section_index =
        panes?.[index]?.is_widget_maker_open_obj?.section_index;
      let widget_index = panes?.[index]?.is_widget_maker_open_obj?.widget_index;

      let updatePanes = [...panes];
      if (section_index >= 0) {
        let obj = {
          open_flag: false,
          section_index: null,
          widget_index: null,
        };
        updatePanes[index].is_widget_maker_open_obj = obj;
        updatePanes[index].edited_widgetGraphConfig = null;
      } else {
        let obj = {
          open_flag: false,
          section_index: null,
          widget_index: null,
        };
        updatePanes[index].is_widget_maker_open_obj = obj;
        updatePanes[index].edited_widgetGraphConfig = null;
      }

      // console.log("On Back updatePanes", updatePanes);
      dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });

      // Reset Widget GraphConfig
      dispatch(
        setY_attribute({
          x_axis: null,
          y_axis: {
            y_series_1: {
              attribute: null,
              aggregation: null,
            },
          },
          y_axis_settings: [],
          breakdown_by: [],
          filter_by: [],
          fields: [],
          chart_type: "line",
          duration: null,
          brands: null,
          filters: [],
          show_marker: true,
          card_position: "Top",
          card_limit: 5,
          card_settings: [
            {
              card_id: uuid(),
              card_name: 1,
              card_value: null,
              x_axis: null,
              y_series: null,
              response: [],
            },
          ],
          rich_fields_content: null,
          chart_settings: {
            global_data_label: false,
            show_details_on_card: false,
            is_stacked: true,
            data_count_card: true,
            duration_comparison: false, // This is used for only KPI
            show_previous_duration_comparison: false, // This is used for charts
            show_previous_duration_data: false, // This is used for charts
            show_as_median: false, // this is used for scatter chart
            card_percent: true,
            chart_percent: false,
            gradient_color: false,
            group_line_agg: null,
            benchmark_line: false,
            benchmark_static_value: null,
            duplicate_for_brands: false,
            split_cards: true,
            wordcloud_color: "0",
            top_posts_in_cards: false,
            show_header: true,
            show_peak: true,
            show_valley: true,
            chart_styles: null,
          },
          chart_property: {
            chart_name: widgetGraphConfig?.chart_property?.chart_name,
            legend_position: "bottom",
            y_axis_mode: 2,
            no_of_top_posts: 1,
          },
          widget_description: widgetGraphConfig?.widget_description,
          dragDataType: {
            varchar: false,
            int: false,
            datetime: false,
            json: false,
          },
          edit_fields: {
            boolValue: false,
            series: "",
            data: "",
          },
          order_by: null,
          custom_attribute: {
            name: null,
            description: null,
            formula: null,
            custom_column: [
              {
                parameters: {
                  attribute: null,
                  display_name: null,
                  data_type: null,
                  selected: true,
                },
                operator: { value: null, selected: false },
                pair: {
                  parameters: {
                    attribute: null,
                    display_name: null,
                    data_type: null,
                    selected: false,
                  },
                  numeric: { value: null, selected: false },
                },
                combined_operator: {
                  value: null,
                  selected: false,
                },
              },
            ],
          },
          widgetResetState: true,
          tags: widgetGraphConfig?.tags,
          filter_by_data: [],
          postcard_pills_filter: null,
          filter_dropdown: [],
          filter_by_dropdown: [],
          filter_by_dropdown_data: [],
          multilevel_breakdown: null,
        })
      );
    } else {
      let obj = {
        search_text: "",
        pill: "All Widgets",
        offset: 0,
        no_of_rows: 12,
        sort_expression: "created_date",
        sort_order: "desc",
        chart_type: "",
        attribute: "",
      };
      dispatch(setWidgetLibraryFilter(obj));
      if (typeof widgetMakerGraphData === "string") {
        setOpenAlertModal(true);
        setVisible(false);
        setflag(false);
      } else {
        let widget_obj = {
          isEditWidget,
          id,
        };
        const d = new Date();
        let utcOffset = d.getTimezoneOffset();
        let twoMonthsDuration = getCustomizedDate(6, "Days");
        let defaultDuration = {
          from:
            moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
            " " +
            twoMonthsDuration?.time?.startTime,
          to:
            moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
            " " +
            twoMonthsDuration?.time?.endTime,
        };
        let y_series_array = [];
        y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
          (key) => widgetGraphConfig?.y_axis[key]
        );
        y_series_array = y_series_array?.filter((e) => e?.attribute);
        let card_settings_data = [];
        widgetGraphConfig?.card_settings?.map((d) => {
          if (d?.x_axis || (d?.x_axis == null && d?.y_series)) {
            card_settings_data = [
              ...card_settings_data,
              {
                x_axis:
                  d?.x_axis == null
                    ? null
                    : Object.keys(d?.x_axis).length == 0
                    ? null
                    : {
                        ...d?.x_axis,
                        trace_name: d?.x_axis?.trace_name
                          ? d?.x_axis?.trace_name
                          : All_WM_attributes[d?.x_axis?.attribute] +
                            " With " +
                            All_WM_attributes[d?.y_series?.attribute],
                      },
                y_series: d?.y_series,
              },
            ];
          }
        });

        let updatedOrderBy;
        if (widgetGraphConfig?.order_by) {
          updatedOrderBy = {
            ...widgetGraphConfig?.order_by,
            offset: 0,
          };
        }

        let saveObject = {
          data_source: data_source,
          authParams: authParams,
          chart: {
            chart_type: widgetGraphConfig?.chart_type,
            rich_fields_content: widgetGraphConfig?.rich_fields_content,
            chart_settings: {
              grid_config: widgetGraphConfig?.chart_settings?.grid_config,
              duration_comparison:
                widgetGraphConfig?.chart_settings?.duration_comparison,
              show_previous_duration_comparison:
                widgetGraphConfig?.chart_settings
                  ?.show_previous_duration_comparison,
              show_previous_duration_data:
                widgetGraphConfig?.chart_settings?.show_previous_duration_data,
              show_data_labels: widgetGraphConfig?.chart_settings
                ?.global_data_label
                ? widgetGraphConfig?.chart_settings?.global_data_label
                : false,
              show_details_on_card:
                widgetGraphConfig?.chart_settings?.show_details_on_card,
              show_as_median: widgetGraphConfig?.chart_settings?.show_as_median
                ? widgetGraphConfig?.chart_settings?.show_as_median
                : false, // this is used for scatter chart
              show_label_names: widgetGraphConfig?.chart_settings
                ?.show_label_names
                ? widgetGraphConfig?.chart_settings?.show_label_names
                : false,
              duplicate_for_brands: widgetGraphConfig?.chart_settings
                ?.duplicate_for_brands
                ? widgetGraphConfig?.chart_settings?.duplicate_for_brands
                : false,
              is_stacked: widgetGraphConfig?.chart_settings?.is_stacked,
              show_count_cards:
                widgetGraphConfig?.chart_settings?.data_count_card,
              card_percent: widgetGraphConfig?.chart_settings?.card_percent, //	card_percent is share of data
              chart_percent: widgetGraphConfig?.chart_settings?.chart_percent,
              gradient_color: widgetGraphConfig?.chart_settings?.gradient_color,
              total_row: widgetGraphConfig?.chart_settings?.total_row,
              split_cards: widgetGraphConfig?.chart_settings?.split_cards,
              wordcloud_color:
                widgetGraphConfig?.chart_settings?.wordcloud_color,
              top_posts_in_cards:
                widgetGraphConfig?.chart_settings?.top_posts_in_cards,
              show_header:
                typeof widgetGraphConfig?.chart_settings?.show_header ===
                "boolean"
                  ? widgetGraphConfig?.chart_settings?.show_header
                  : true, // default to true
              chart_property: {
                chart_name: widgetGraphConfig?.chart_property?.chart_name,
                legend_position:
                  widgetGraphConfig?.chart_property?.legend_position,
                show_legend: widgetGraphConfig?.chart_property?.show_legend,
                y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
                no_of_top_posts:
                  widgetGraphConfig?.chart_property?.no_of_top_posts,
              },
              show_marker: widgetGraphConfig?.show_marker,
              card_position: widgetGraphConfig?.card_position,
              card_limit: widgetGraphConfig?.card_limit,
              y_axes_settings: widgetGraphConfig?.y_axis_settings,
              cards_settings: card_settings_data ? card_settings_data : null,
              show_3d: widgetGraphConfig?.chart_settings?.show_3d,
              settings_3d: {
                alpha: widgetGraphConfig?.chart_settings?.settings_3d?.alpha,
                beta: widgetGraphConfig?.chart_settings?.settings_3d?.beta,
                depth: widgetGraphConfig?.chart_settings?.settings_3d?.depth,
              },
              show_peak: widgetGraphConfig?.chart_settings?.show_peak,
              show_valley: widgetGraphConfig?.chart_settings?.show_valley,
              show_horizontal_view:
                widgetGraphConfig?.chart_settings?.show_horizontal_view,
              chart_styles:
                widgetGraphConfig?.chart_settings?.chart_styles || null,
              cluster_chart_type:
                widgetGraphConfig?.chart_settings?.cluster_chart_type,
              cluster_style: widgetGraphConfig?.chart_settings?.cluster_style,
            },
          },
          widget_name: chartName
            ? chartName
            : widgetGraphConfig?.chart_property?.chart_name,
          widget_description: description,

          x_axis: widgetGraphConfig?.x_axis,
          y_axes:
            widgetGraphConfig?.breakdown_by?.length > 0
              ? widgetGraphConfig?.breakdown_by
              : widgetGraphConfig?.filter_by?.length > 0
              ? widgetGraphConfig?.filter_by
              : null,
          // for filter dropdown in widget header
          filter_dropdown:
            widgetGraphConfig?.filter_dropdown?.length > 0
              ? widgetGraphConfig?.filter_dropdown
              : [],
          order_by: updatedOrderBy ? updatedOrderBy : null,
          y_series: y_series_array,
          filters: widgetGraphConfig?.filters
            ? widgetGraphConfig?.filters
            : null,
          start_date: widgetGraphConfig?.duration?.from
            ? widgetGraphConfig?.duration?.from
            : defaultDuration?.from,
          end_date: widgetGraphConfig?.duration?.to
            ? widgetGraphConfig?.duration?.to
            : defaultDuration?.to,
          brands:
            widgetGraphConfig?.brands?.length > 0
              ? widgetGraphConfig?.brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands,
          isBrandModified: widgetGraphConfig?.brands ? true : false,
          utcoffset: utcOffset,
          tags: widgetTag ? widgetTag : [],
          search_text: "",
          pill: widgetLibraryFilter?.pill
            ? widgetLibraryFilter?.pill
            : "All Widgets",
          offset: 0,
          no_of_rows: 12,
          sort_expression: "created_date",
          sort_order: "desc",
          chart_type: "",
          attribute: "",
          type: "widget-maker",
          multilevel_breakdown: widgetGraphConfig?.multilevel_breakdown,
        };
        // Check and update chart settings based on benchmark line case
        let updatedSaveObject =
          updateChartSettingsInGraphObjectBasedOnSelection({
            widgetGraphConfig: widgetGraphConfig,
            brandlogicalgroup: brandlogicalgroup,
            brands: brands,
            graphObject: saveObject,
          });
        if (updatedSaveObject) {
          saveObject = updatedSaveObject;
        }
        dispatch(setCreateWidget(saveObject, widget_obj));
        setVisible(false);
      }
    }
  };

  return (
    <Modal
      visible={visible}
      className={`p-0 previewModal ${
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }`}
      // title="Alert"
      width={"40%"}
      height={"30%"}
      style={{ top: "3rem" }}
      onCancel={modalClose}
      footer={[
        <Button type="button" onClick={modalClose}>
          No
        </Button>,
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={
            type === "reset_widget_maker" ? resetWidgetMaker : handleExitWidget
          }
        >
          Yes
        </Button>,
      ]}
      transitionName=""
      maskTransitionName=""
    >
      <div
        className="custom_scroll1 m-2 p-15"
        style={{ height: "10rem", overflow: "auto" }}
      >
        <div className="mb-0 text_heading-Slab text-transform__none">
          {type === "reset_widget_maker"
            ? "Are you sure you want to reset?"
            : "Are you sure you want to exit?"}
        </div>
        <div className="text_regular">
          {type === "reset_widget_maker"
            ? "All your changes will be lost if you reset this page"
            : "All your unsaved changes will be lost if you exit this page"}
        </div>
      </div>
    </Modal>
  );
};

export default ExitModal;
